import styled from '@emotion/styled';
import { PencilButton } from '../../icons/Pencil';
import { User } from '../../icons/User';

export type TagDetailsBannerImageProps = {
  label?: string;
  value?: string;
  /** If provided, renders an edit button and makes the image clickable. */
  onEditClick?: () => void;
  themedColor?: string;
};

export const TagDetailsBannerImage = ({
  label = 'Dashboard Banner Image',
  value,
  onEditClick,
  themedColor,
}: TagDetailsBannerImageProps) => (
  <Root>
    <Label>{label}</Label>
    <Value>
      <EditableContainer>
        <ImageContainer onClick={onEditClick} style={{ cursor: onEditClick ? 'pointer' : 'default' }}>
          {value ? (
            <BannerImg src={value} alt="Dashboard Banner" draggable="false" />
          ) : (
            <DefaultImage>
              <User size={40} strokeWidth="1px" fill="#626262" />
            </DefaultImage>
          )}
        </ImageContainer>
        {onEditClick && (
          <div style={themedColor ? ({ '--themed-color': themedColor } as React.CSSProperties) : undefined}>
            <PencilButton size={16} onClick={onEditClick} color={themedColor ?? 'var(--pri-02)'} />
          </div>
        )}
      </EditableContainer>
    </Value>
  </Root>
);

TagDetailsBannerImage.displayName = 'TagDetails.BannerImage';

import type React from 'react';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.div`
  font-family: var(--font-bold);
  color: var(--gray-d);
  font-size: 14px;
`;

const Value = styled.div`
  min-height: 20px;
  display: flex;
  align-items: center;
`;

const EditableContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

const ImageContainer = styled.div`
  width: 120px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--gray-l);
  background: var(--gray-xxl);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BannerImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

const DefaultImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
